import posthog from 'posthog-js';

import { UserMeProps } from '@/services/User/types';

import { FeatureFlagsOptions } from '@/hooks/useFeatureFlags/types';

import { ehHostOuCoHost } from './destinoPosLogin';

const ESPERA_DA_FLAG_MS = 3000;

/**
 * Se o Host/CoHost deve ser mandado ao Franquias depois do login.
 *
 * Le a flag do PostHog na resposta da recarga pedida depois de identificar o
 * usuario, com teto de 3 s: flag que nao chega a tempo conta como desligada,
 * e o login segue para o Sapron. As flags que a pagina ja tinha (a avaliacao
 * anonima do `/login` ou do boot da pagina) nao decidem nada.
 * Fora de Host/CoHost, ou sem `REACT_APP_PUBLIC_FRANQUIAS_URL`, nem pergunta.
 */
export function vaiParaFranquias(usuario: UserMeProps, email: string): Promise<boolean> {
  if (!ehHostOuCoHost(usuario) || !import.meta.env.REACT_APP_PUBLIC_FRANQUIAS_URL) {
    return Promise.resolve(false);
  }

  return new Promise<boolean>((resolve) => {
    let settled = false;
    let identificado = false;
    const unsubRef: { fn?: () => void } = {};
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const finish = (value: boolean) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      unsubRef.fn?.();
      resolve(value);
    };

    timeout = setTimeout(() => finish(false), ESPERA_DA_FLAG_MS);

    unsubRef.fn = posthog.onFeatureFlags?.(() => {
      if (!identificado) {
        // As primeiras flags que chegam aqui foram pedidas antes do identify:
        // o cache (o posthog-js chama o handler na hora, no registro) ou o
        // `/flags` do boot da pagina, que na volta do IDP ainda esta em voo ou
        // nem saiu (o `/auth/callback` decide antes do `posthog.init`, e sem
        // init o identify se perde). Identificar aqui, dentro do callback, faz
        // o proximo `/flags` que o posthog-js manda ja sair com o e-mail.
        identificado = true;
        posthog.identify(email, { email });
        posthog.reloadFeatureFlags();
        return;
      }
      finish(!!posthog.getFeatureFlag(FeatureFlagsOptions.FF_REDIRECT_HOST_TO_FRANQUIAS));
    });
  });
}
